export default __webpack_public_path__ + "static/media/step1.7e414a22.png";